module.exports = __webpack_public_path__ + "static/media/macizo.6559cda3.jpg";